import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4107ea36")

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_van_nav_bar, {
      title: _ctx.listObject.name,
      "left-arrow": "",
      onClickLeft: _cache[1] || (_cache[1] = $event => (_ctx.$router.back()))
    }, null, 8, ["title"]),
    _createVNode("video", {
      src: _ctx.listObject.url,
      class: "video",
      controls: "controls",
      autoplay: ""
    }, null, 8, ["src"])
  ], 64 /* STABLE_FRAGMENT */))
})